import React, { useState, useEffect } from "react";
import { getHighlight, updateHighlight } from "../../../apis/Ambition";
import { useUserAccess } from "../../../components/WriteAccessContext";

const CustomRow = ({
  heading,
  keyHighlight,
  table,
  question,
  isPercentageRow = false,
  serviceKey,
  productKey,
}) => {
  const [text, setText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [serviceValue, setServiceValue] = useState("");
  const [productValue, setProductValue] = useState("");
  const { userAccess } = useUserAccess();

  useEffect(() => {
    if (!isPercentageRow) {
      getHighlight({
        key: keyHighlight,
        setValue: setText,
      });
    } else {
      getHighlight({
        key: serviceKey,
        setValue: setServiceValue,
      });
      getHighlight({
        key: productKey,
        setValue: setProductValue,
      });
    }
  }, [keyHighlight, serviceKey, productKey, isPercentageRow]);

  const handleBlur = () => {
    setIsEditing(false);
    if (!isPercentageRow) {
      updateHighlight({
        key: keyHighlight,
        value: text,
        swal: false,
      });
    }
  };

  const handleServiceBlur = () => {
    updateHighlight({
      key: serviceKey,
      value: serviceValue,
      swal: false,
    });
  };

  const handleProductBlur = () => {
    updateHighlight({
      key: productKey,
      value: productValue,
      swal: false,
    });
  };

  return (
    <div className="ambition__role__role mt-2">
      <div className="ambition__ourcompany__item">
        <h5>{heading}</h5>
      </div>
      <div className="ambition__ourcompany__writeinbox__wrapper">
        <div className="ambition__ourcompany__writeinbox p-5 pt-4">
          <div className="mb-2">
            <h6 style={{ fontSize: "0.8rem" }}>{question}</h6>
          </div>

          {isPercentageRow ? (
            <div className="flex flex-col gap-4">
              <div className="customrow_input">
                <span style={{ fontSize: "14px", marginRight: "2px" }}>
                  % Service:
                </span>
                {userAccess === "write" && (
                  <input
                    type="text"
                    style={{
                      padding: "0 5px",
                      border: "none",
                      borderBottom: "none",
                      background: "none",
                      outline: "none",
                      color: "white",
                    }}
                    placeholder="_ _ _ _ _"
                    value={serviceValue}
                    onChange={(e) => setServiceValue(e.target.value)}
                    onBlur={handleServiceBlur}
                  />
                )}
              </div>
              <div className="customrow_input">
                <span style={{ fontSize: "14px", marginRight: "2px" }}>
                  % Products:
                </span>
                {userAccess === "write" && (
                  <input
                    type="text"
                    style={{
                      padding: "0 5px",
                      border: "none",
                      background: "none",
                      borderBottom: "none",
                      outline: "none",
                      color: "white",
                    }}
                    placeholder="_ _ _ _ _"
                    value={productValue}
                    onChange={(e) => setProductValue(e.target.value)}
                    onBlur={handleProductBlur}
                  />
                )}
              </div>
            </div>
          ) : table ? (
            table
          ) : (
            <div
              className="min-h-[100px] border rounded p-2"
              onClick={() => setIsEditing(true)}
            >
              {isEditing && userAccess === "write" ? (
                <textarea
                  className="w-full h-full border-none resize-none focus:outline-none"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  onBlur={handleBlur}
                  autoFocus
                />
              ) : (
                <div className="w-full h-full">
                  {userAccess === "write"
                    ? text || "Click to edit"
                    : text || ""}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomRow;
